module.exports = __webpack_public_path__ + "static/media/ve.3b7845e9.svg";